import React, { useState } from "react";

import { Sidebar } from "../components/sections/navigation/dashboard/SideBar";
import { Header } from "../components/sections/navigation/dashboard/Header";

// Types
interface LayoutProps {
  children: React.ReactNode;
}

// Layout Component
export const AdminLayout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar isCollapsed={sidebarCollapsed} setIsCollapsed={setSidebarCollapsed} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} />

        <main className="flex-1 overflow-y-auto p-4">{children}</main>
      </div>
    </div>
  );
};
